import { useMemo } from "react";
import { FormBuilder, Message, Modal } from "shared/components";
import { IFormButtons, IStatus } from "shared/types";

interface DeleteEditRowModalProps {
  id: string;
  title: string;
  message: string;
  handleConfirm: (id: string) => void;
  handleClose: () => void;
}

export const DeleteEditRowModal = ({
  id,
  title,
  message,
  handleConfirm,
  handleClose,
}: DeleteEditRowModalProps) => {
  const buttons = useMemo(
    (): IFormButtons => ({
      primary: {
        children: "Delete",
        size: "m",
        status: IStatus.error,
      },
      secondary: {
        onClick: handleClose,
        size: "m",
      },
    }),
    [handleClose]
  );

  return (
    <Modal title={title} handleClose={handleClose}>
      <Message status={IStatus.warning} message={message} />
      <FormBuilder buttons={buttons} fields={[]} onSubmit={() => handleConfirm(id)} />
    </Modal>
  );
};
